module.exports = __GETREMOTE__('KIWI');